/**
 * Display-name helpers shared by the printed record's row builder
 * (`components/production/record-insights.ts`) and the unified input's row
 * model (`lib/production-records/spreadsheet-model.ts`), so the paper and the
 * screen name a component the same way (PROD-1441). Pure — no React, no I/O.
 */

/**
 * Strip one balanced trailing " (…)" tail from a display name —
 * "Baby Carrot, Fresh (Cheese Pizza Calzone)" → "Baby Carrot, Fresh".
 * Inner parentheses survive: "Fruit Cup (approx. 4.5 oz) (Cereal & String
 * Cheese)" → "Fruit Cup (approx. 4.5 oz)". A name without a trailing tail
 * (or that IS entirely one parenthetical) is returned untouched. Pure.
 */
export function stripParentheticalTail(name: string): string {
  const trimmed = name.trimEnd()
  if (!trimmed.endsWith(')')) {
    return name
  }
  let depth = 0
  for (let i = trimmed.length - 1; i >= 0; i--) {
    const ch = trimmed[i]
    if (ch === ')') {
      depth++
    } else if (ch === '(') {
      depth--
      if (depth === 0) {
        const head = trimmed.slice(0, i).trimEnd()
        return head === '' ? name : head
      }
    }
  }
  return name
}
